import { render, staticRenderFns } from "./DPEnviromentTableMenu.vue?vue&type=template&id=4e5277f5&scoped=true&"
import script from "./DPEnviromentTableMenu.vue?vue&type=script&lang=js&"
export * from "./DPEnviromentTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5277f5",
  null
  
)

export default component.exports